import { render, staticRenderFns } from "./editChegua.vue?vue&type=template&id=781dd8b7&scoped=true&"
import script from "./editChegua.vue?vue&type=script&lang=js&"
export * from "./editChegua.vue?vue&type=script&lang=js&"
import style0 from "./editChegua.vue?vue&type=style&index=0&id=781dd8b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781dd8b7",
  null
  
)

export default component.exports